'use client';

import { Phone } from '@hc-frontend/core-icons/kit';
import { PhoneCampaign } from '@hc-frontend/core-types';
import { useSSE } from '@hc-frontend/core-ui';
import { CallCta } from '@hc-frontend/shells-shared';

export function StickyMobileCallBanner({
  phoneCampaign,
  showSchedule = false,
}: {
  readonly phoneCampaign: PhoneCampaign;
  readonly showSchedule?: boolean;
}) {
  const { phoneNumber, tty, todayTTY, schedule } = phoneCampaign;
  const phoneNumberAndTty = `${phoneNumber} (${tty})`;
  const { start } = useSSE();

  return (
    <div className="sticky bg-secondary-50 text-gray-400 bottom-0 left-0 w-full text-center z-50 block tablet:hidden px-12-12 py-8-8">
      <p>
        <strong>Speak with a licensed insurance agent</strong>
      </p>
      <CallCta
        onClick={start}
        phoneCampaign={phoneCampaign}
        className="hc-typography--heading-three block my-8-8"
      >
        <Phone
          data-testid="call-cta-phone"
          className="inline w-[24px] h-[24px] mr-4-4"
        />
        {phoneNumberAndTty}
      </CallCta>
      <p>
        <strong>{showSchedule ? `${schedule} ${todayTTY}` : todayTTY}</strong>
      </p>
    </div>
  );
}
